import Gator from "gator";

const SELECTOR = ".input--with-placeholder .input__field";
const CHOOSE_ONE = ".-js-choose-one .input--checkbox input";

function setClass(element) {
    element.classList[element.value ? "add" : "remove"](
        "input__field--not-empty"
    );
}

Gator(document).on("change", SELECTOR, function() {
    setClass(this);
});

Gator(document).on("change", CHOOSE_ONE, function() {
    let elements = document.querySelectorAll(CHOOSE_ONE);
    let checked = false;
    for (let index = 0; index < elements.length; index++) {
        const element = elements[index];
        element.required = false;
        if (element.checked) {
            checked = element;
        }
    }

    (checked || this).required = true;
});

_gg.onReady.Form = () => {
    let firstCheckbox = document.querySelector(CHOOSE_ONE);
    if (firstCheckbox) {
        firstCheckbox.required = true;
    }

    let elements = document.querySelectorAll(SELECTOR);
    for (let index = 0; index < elements.length; index++) {
        setClass(elements[index]);
    }
};

// Spam Protection

function addEvents() {
    document.addEventListener('touchstart', insertSpamProtectionValue, true);
    document.addEventListener('keydown', insertSpamProtectionValue, true);
    document.addEventListener('mousemove', insertSpamProtectionValue, true);
    document.addEventListener('touchmove', insertSpamProtectionValue, true);
}

function removeEvents() {
    document.removeEventListener('touchstart', insertSpamProtectionValue, true);
    document.removeEventListener('keydown', insertSpamProtectionValue, true);
    document.removeEventListener('mousemove', insertSpamProtectionValue, true);
    document.removeEventListener('touchmove', insertSpamProtectionValue, true);
}

function insertSpamProtectionValue() {
    const fields = document.querySelectorAll('.js-spam-protection-field');
    [...fields].forEach(field => {
        const form = field.closest('form');

        if (!form) {
            return;
        }

        const stateField = form.querySelector('input[name*=__state');

        if (stateField) {
            field.value = stateField.value;
        }
    });

    removeEvents();
}

if (document.querySelectorAll('.js-spam-protection-field').length > 0) {
    addEvents();
}
